import type { ReactNode } from "react";
import Panel from "./Panel.tsx";

interface SectionCardProps {
  title: ReactNode;
  /** Right of the title, e.g. a small button. */
  action?: ReactNode;
  children: ReactNode;
}

/** A titled section on a detail page: a `Panel` with the gap detail pages stack them with. */
export default function SectionCard({ title, action, children }: SectionCardProps) {
  return (
    <Panel title={title} action={action} sx={{ mb: 3 }}>
      {children}
    </Panel>
  );
}
